import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/modal';
import { Button } from 'components/ui/button';
import { delay } from 'lodash';
import { post } from '../../helpers/api';

const ApplyToAllSitesConfirmModal = ({ open, onClose, onConfirm, confirmPath }) => {
  const [loading, setLoading] = useState(false);

  const confirm = () => {
    setLoading(true);
    post(confirmPath, {}).then(() => {
      onConfirm();
      onClose();
      delay(() => setLoading(false), 500);
    });
  };

  return <Modal bsSize="small" className="visible-overflow" show={open} onHide={onClose}>
    <Modal.Header closeButton>
      Apply Default Options to ALL your sites
    </Modal.Header>

    <Modal.Body>
      Are you sure you want to apply your current default options to all your sites?
      This will overwrite all your sites' current options
    </Modal.Body>

    <Modal.Footer>
      <Button label="Cancel" variant="ghost" onClick={onClose} />
      <Button disabled={loading} label={loading ? 'Starting...' : 'Confirm'} onClick={confirm}/>
    </Modal.Footer>
  </Modal>;
};

ApplyToAllSitesConfirmModal.propTypes = {
  confirmPath: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ApplyToAllSitesConfirmModal;
